import React from 'react';
import rightArrowIcon from '../../icons/SVG/angle-right-solid (2).svg';
import './Breadcrumb.css';

function Breadcrumb(props) {
  const linkClasses = 'font-mont font-w-400 text-10 leading-10 tracking-1 text-dark-grey uppercase';
  const activeLinkClasses = 'font-mont-700 font-w-700 text-10 leading-10 tracking-1 text-almost-black uppercase';
  const rightArrowClasses = 'inline mt-2 ml-12 mr-9 w-3 h-6';

  return (
    <div className="flex-shrink hidden md:block">
      <div className="w-full mx-auto my-0 max-w-w-7xl flex">
        <nav aria-label="Secondary navigation" className="h-40 mb-20 pt-10">
          {props.breadcrumbs.map(function(item, idx) {
            const isLastItem = idx === props.breadcrumbs.length - 1;

            return (
              <React.Fragment key={item.label}>
                <a className={isLastItem ? activeLinkClasses : linkClasses} href={item.link}>
                  {item.label}
                </a>
                {!isLastItem && <img src={rightArrowIcon} alt="" aria-hidden="true" className={rightArrowClasses} />}
              </React.Fragment>
            );
          })}
        </nav>
      </div>
    </div>
  );
}

export default Breadcrumb;
